// extracted by mini-css-extract-plugin
export default {"giftPointBody":"CustomerPoint_giftPointBody__ZtG8M","okBtn":"CustomerPoint_okBtn__RBB+f"};